module.exports = __webpack_public_path__ + "img/white.71b35cbb.svg";